export const getParamFromUrl = (paramName: string): string | null => {
  const url = new URL(window.location.href);
  return url.searchParams.get(paramName);
};
